/**
 * 電話番号をハイフン区切りで表示する
 * @param number
 * @returns
 */
const formatNumber = (number: string | undefined) => {
  if (!number) return '';
  return `${number.substring(0, 3)}-${number.substring(
    3,
    7,
  )}-${number.substring(7)}`;
};

export { formatNumber };
